An array of offered salary ranges.

The `seekAnz` scheme will always have a single element containing the amount for the `basisCode`.
